export const panelItemsToText = (items) =>
  (Array.isArray(items) ? items : []).join('\n');

export const textToPanelItems = (text) =>
  String(text || '')
    .split('\n')
    .map((line) => line.trim())
    .filter(Boolean);
